import { useLocation } from 'react-router-dom'

// When we return from a payment provider we need to render the checkout component to complete the purchase
export const useIsAdyenReturn = () => {
  const { search } = useLocation()
  const params = new URLSearchParams(search)

  return Boolean(params.get('sessionId'))
}
